import { SnMapClusterPoint } from '@lib/api';
import { SnLocation } from '@lib/api/entities';
import { colorIsDark } from '@lib/common/helpers';
import { COLORS } from '@lib/ui/theme';
import { FsAdvancedMarker } from '@lib/geo/google/map';

export class FsLocationAdvancedMarker extends FsAdvancedMarker {
  constructor(public location: SnLocation, public cluster?: SnMapClusterPoint) {
    super(
      {
        position: cluster
          ? new google.maps.LatLng(cluster.geometry.coordinates[1], cluster.geometry.coordinates[0])
          : new google.maps.LatLng(
              location.geometry.coordinates[1],
              location.geometry.coordinates[0],
            ),
        title: location ? location.name : null,
        collisionBehavior: google.maps.CollisionBehavior.OPTIONAL_AND_HIDES_LOWER_PRIORITY,
      },
      null,
      cluster,
    );
    if (cluster) {
      const content = document.createElement('div');
      content.innerHTML = `
      <i class="fa-solid fa-city"></i>
      `;
      content.classList.add('fs__location-cluster-advanced-marker');
      this.getMarker().content = content;
      this.createBadge();
    } else {
      const icon = document.createElement('div');
      icon.innerHTML = `
      <i class="fa" id="fs__advanced-location-${location.id}">&#x${location.type.icon};</i>
      `;
      const faPinView = new google.maps.marker.PinElement({
        glyph: icon,
        glyphColor: colorIsDark(location.type?.color) ? COLORS['grey-0'] : '#000000',
        background: location.type.color,
        borderColor: location.type.color,
      });
      this.getMarker().content = faPinView.element;
    }
  }
}
